/* Style It With - placement, drag/swipe carousel, dots, colour swatches. No jQuery, no globals. */
(function () {
  'use strict';

  function place(root) {
    var buy = document.querySelector('buy-buttons.buy-buttons-row') || document.querySelector('.buy-buttons-row');
    if (buy && buy.parentNode) { buy.insertAdjacentElement('afterend', root); return; }
    var anchor = document.querySelector('.section-related-products');
    if (anchor && anchor.parentNode && anchor !== root && !anchor.contains(root)) {
      anchor.parentNode.insertBefore(root, anchor); return;
    }
    var main = document.querySelector('#content .container')
            || document.querySelector('main .container')
            || document.querySelector('main');
    if (main && main !== root.parentNode) { main.appendChild(root); }
  }

  function stepWidth(track, items) {
    if (items.length > 1) { return items[1].offsetLeft - items[0].offsetLeft; }
    return track.clientWidth;
  }

  // Manual smooth scroll: set scrollLeft each frame, because scroll-snap cancels
  // the native behavior:'smooth'.
  function animateTo(track, target) {
    target = Math.max(0, target);
    var start = track.scrollLeft;
    var dist = target - start;
    if (Math.abs(dist) < 2) { track.scrollLeft = target; return; }
    var duration = 320, startTime = null;
    function ease(t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; }
    function frame(ts) {
      if (startTime === null) startTime = ts;
      var p = Math.min(1, (ts - startTime) / duration);
      track.scrollLeft = start + dist * ease(p);
      if (p < 1) { requestAnimationFrame(frame); }
      else { track.scrollLeft = target; }
    }
    requestAnimationFrame(frame);
  }

  function goTo(track, step, index, count) {
    var target = Math.max(0, Math.min(count - 1, index));
    animateTo(track, target * step);
  }

  // Click a colour swatch: swap the card image/colour/price and repoint its links.
  function enableSwatches(root) {
    root.addEventListener('click', function (e) {
      var sw = e.target.closest ? e.target.closest('[data-siw-swatch]') : null;
      if (!sw) return;
      var card = sw.closest('[data-siw-card]');
      if (!card) return;
      var img = card.querySelector('[data-siw-image]');
      var imgUrl = sw.getAttribute('data-image');
      if (img && imgUrl) { img.removeAttribute('srcset'); img.setAttribute('sizes', ''); img.src = imgUrl; }
      var colorEl = card.querySelector('[data-siw-color]');
      var color = sw.getAttribute('data-color');
      if (colorEl && color) { colorEl.textContent = color; }
      var priceEl = card.querySelector('[data-siw-price]');
      var price = sw.getAttribute('data-price');
      if (priceEl && price) { priceEl.textContent = price; }
      var url = sw.getAttribute('data-url');
      if (url) {
        Array.prototype.forEach.call(card.querySelectorAll('[data-siw-link]'), function (a) { a.setAttribute('href', url); });
      }
      Array.prototype.forEach.call(card.querySelectorAll('[data-siw-swatch]'), function (s) { s.removeAttribute('aria-current'); });
      sw.setAttribute('aria-current', 'true');
    });
  }

  // Classic mouse drag-to-scroll with flick-to-advance. Touch scrolls natively.
  function enableDrag(track, items) {
    var count = items.length;
    var isDown = false, startX = 0, startScroll = 0, dx = 0, moved = false;
    track.style.cursor = 'grab';

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    Array.prototype.forEach.call(track.querySelectorAll('a, img'), function (el) {
      el.setAttribute('draggable', 'false');
    });

    function onMove(e) {
      if (!isDown) return;
      dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      track.scrollLeft = startScroll - dx;
      e.preventDefault();
    }

    function onUp() {
      if (!isDown) return;
      isDown = false;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      track.style.cursor = 'grab';
      document.body.style.userSelect = '';
      if (moved) {
        var step = stepWidth(track, items);
        var startIdx = Math.round(startScroll / step);
        var target = startIdx;
        if (dx <= -40) { target = startIdx + 1; }
        else if (dx >= 40) { target = startIdx - 1; }
        goTo(track, step, target, count);
      }
    }

    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true; moved = false; dx = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.style.cursor = 'grabbing';
      document.body.style.userSelect = 'none';
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
      e.preventDefault();
    });

    // If the pointer was dragged, swallow the click so it neither navigates nor changes colour.
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function init(root) {
    if (!root || root.dataset.siwReady) return;
    root.dataset.siwReady = '1';
    place(root);
    enableSwatches(root);
    var track = root.querySelector('[data-siw-track]');
    if (!track) return;
    var items = Array.prototype.slice.call(track.children);
    if (items.length <= 1) return;
    enableDrag(track, items);
    var dots = document.createElement('div');
    dots.className = 'siw__dots';
    var buttons = items.map(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'siw__dot';
      b.setAttribute('aria-label', 'Go to item ' + (i + 1));
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        goTo(track, stepWidth(track, items), i, items.length);
      });
      dots.appendChild(b);
      return b;
    });
    root.appendChild(dots);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var idx = items.indexOf(entry.target);
          if (idx < 0) return;
          buttons.forEach(function (btn, bi) {
            if (bi === idx) { btn.setAttribute('aria-current', 'true'); }
            else { btn.removeAttribute('aria-current'); }
          });
        });
      }, { root: track, threshold: 0.6 });
      items.forEach(function (item) { io.observe(item); });
    }
  }

  function boot() {
    var root = document.querySelector('[data-siw]');
    if (root) init(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();